



import ContentsListComponent from "@/components/admin/download/downloadListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "DownloadListPage",
  components: {
    ContentsListComponent,
  },
})
export default class DownloadListPage extends Vue {}
